export default __webpack_public_path__ + "static/media/South Sudan.66aa0156.png";